import React from 'react';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { TachoConfirmationFooter } from './footer';
import styles from './styles.module.scss';
import { Icon } from 'tacho-ui';
import { TachoModalHeader } from '../TachoModal/TachoModalHeader';
import { TachoEditModalTitle } from '../TachoModal/TachoEditTitle';

interface TachoConfirmationModalProps extends React.PropsWithChildren {
    title?: string;
    titleTranslated?: string;
    message?: string;
    messageTranslated?: string;
    isOpen: boolean;
    size?: string;
    height?: 'auto' | 'full';
    submitDisabled?: boolean;
    pending?: boolean;
    notCloseOnSubmit?: boolean;
    errorToTranslate?: string;
    additionalButton?: () => JSX.Element;
    onSubmit: (data?: any) => void;
    onDismiss?: () => void;
    onToggle: () => void;
}

export class TachoConfirmationModal extends React.Component<TachoConfirmationModalProps> {
    public render(): JSX.Element {
        return (
            <Modal
                size={this.props.size || 'sm'}
                isOpen={this.props.isOpen}
                modalClassName={`${styles.modalParent}`}
                className={`${styles.modal} ${this.props.height === 'full' ? styles.fullHeight : ''}`}
                contentClassName={styles.modalContent}
                toggle={this.props.onToggle}
                backdrop="static"
            >
                <TachoModalHeader
                    onToggle={this.props.onToggle}
                    className={styles.confirmationModal}
                    titleHorizontalLine={false}
                    title={
                        <TachoEditModalTitle
                            titleToTranslation={this.props.title}
                            titleTranslated={this.props.titleTranslated}
                            icon={Icon.Information}
                            className={styles.tachoModalTitleColor}
                        />
                    }
                />

                <ModalBody className={styles.modalBody}>
                    {this.props.children}
                    {this.props.message && <FormattedMessage id={this.props.message} />}
                    {this.props.messageTranslated}
                </ModalBody>
                <ModalFooter>
                    <TachoConfirmationFooter
                        errorToTranslate={this.props.errorToTranslate}
                        submitDisabled={this.props.submitDisabled}
                        pending={this.props.pending}
                        onToggle={() => {
                            this.props.onToggle();
                            this.props.onDismiss && this.props.onDismiss();
                        }}
                        onSubmit={() => {
                            this.props.onSubmit();
                            !this.props.notCloseOnSubmit && this.props.onToggle();
                        }}
                        additionalButton={this.props.additionalButton}
                    />
                </ModalFooter>
            </Modal>
        );
    }
}
